import React from 'react';

const JS_HTML_Events = () => {
  return (
    <div >
      <h1>JS_HTML_Events</h1>
      <p>Placeholder component for: "JS HTML Events"</p>
    </div>
  );
};

export default JS_HTML_Events;
